<template>
<div>
  <van-nav-bar title="微考勤" left-text=""/>
  <van-notice-bar
    wrapable
    :scrollable="false"
    text="当前访问未授权！"
  />
</div>
</template>

<script>
export default {
  name: "Error"
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

/*.van-nav-bar {*/
/*  background-color: #ecf9ff;*/
/*}*/

/*/deep/ .van-nav-bar__title {*/
/*  color: #1989fa;*/
/*}*/

/*/deep/ .van-nav-bar__text {*/
/*  color: #1989fa;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/Error.vue